import { Component, input, OnInit, output } from '@angular/core';

import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';

export interface SimpleModalOptions {
  title: string;
  content: string;
  confirmButton?: string;
  cancelButton?: string;
  modalHeight?: number;
}
@EnableClassTelemetry()
@Component({
  selector: 'app-lex-xi-simple-modal',
  templateUrl: './lex-xi-simple-modal.component.html',
  styleUrls: ['./lex-xi-simple-modal.component.scss'],
  standalone: false,
})
export class LexXiSimpleModalComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  constructor() {}
  readonly data = input<SimpleModalOptions>();
  readonly modalClosed = output<boolean>();
  title: string;
  content: string;
  confirmButton: string;
  cancelButton: string;
  containerHeight: number;
  contentHeight: number;
  DEFAULT_CONTAINER_HEIGHT = 360;
  //Cumulative height of non-variable-height elements (eg: title)
  OFFSET_HEIGHT = 196;

  ngOnInit(): void {
    this.title = this.data().title;
    this.content = this.data().content;
    this.confirmButton = this.data().confirmButton;
    this.cancelButton = this.data().cancelButton;
    this.containerHeight = this.data().modalHeight || this.DEFAULT_CONTAINER_HEIGHT;
    this.contentHeight = this.containerHeight - this.OFFSET_HEIGHT;
  }

  onCancel(): void {
    this.modalClosed.emit(false);
  }

  onConfirm(): void {
    this.modalClosed.emit(true);
  }
}
